import api from './api';

export interface FollowStatus {
  is_following: boolean;
  can_follow: boolean;
  message?: string;
}

export interface Follower {
  id: number;
  username: string;
  full_name: string | null;
  avatar: string | null;
  bio: string | null;
  followed_at: string | null;
}

export interface Following {
  id: number;
  username: string;
  full_name: string | null;
  avatar: string | null;
  bio: string | null;
  followed_at: string | null;
}

export interface FollowersResponse {
  followers: Follower[];
  total: number;
  page: number;
  per_page: number;
  pages: number;
}

export interface FollowingResponse {
  following: Following[];
  total: number;
  page: number;
  per_page: number;
  pages: number;
}

export const followService = {
  followUser: async (userId: number) => {
    const response = await api.post<{ message: string; follow: any }>(`/users/${userId}/follow`);
    return response.data;
  },

  unfollowUser: async (userId: number) => {
    const response = await api.delete<{ message: string }>(`/users/${userId}/follow`);
    return response.data;
  },

  getFollowStatus: async (userId: number) => {
    const response = await api.get<FollowStatus>(`/users/${userId}/follow-status`);
    return response.data;
  },

  getFollowers: async (userId: number, params?: { page?: number; per_page?: number }) => {
    const response = await api.get<FollowersResponse>(`/users/${userId}/followers`, { params });
    return response.data;
  },

  getFollowing: async (userId: number, params?: { page?: number; per_page?: number }) => {
    const response = await api.get<FollowingResponse>(`/users/${userId}/following`, { params });
    return response.data;
  },
};

